import React from 'react'
import { FooterComponent, NavbarComponent } from '../../SharedComponents'
import BackToNatureSection from './BackToNatureSection'
import ApproachSection from './ApproachSection'
import VisionSection from './VisionSection'
import TitleSection from './TitleSection'
import HeroSection from './HeroSection'
import './SustainabilityPage.css'

export default function SustainabilityPage() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
    return (
        <div>
            <NavbarComponent />
            <TitleSection />
            <HeroSection />
            <VisionSection />
            <ApproachSection />
            <BackToNatureSection />
            <FooterComponent />
        </div>
    )
}
